import { db } from '../firebase/config'
import { collection, addDoc, deleteDoc, doc, setDoc } from 'firebase/firestore'

export const useFirestore = col => {
	const ref = collection(db, col)

	// add doc
	const addDocument = async obj => {
		await addDoc(ref, obj)
	}

	const updateDocument = async (id, obj) => {
		const docRef = doc(ref, id)
		await setDoc(docRef, obj, { merge: true })
	}

	// delete doc
	const deleteDocument = async id => {
		await deleteDoc(doc(ref, id))
	}

	return { addDocument, deleteDocument, updateDocument }
}
